import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=8690c3f6&scoped=true&"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&id=8690c3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8690c3f6",
  null
  
)

export default component.exports